module.exports = __webpack_public_path__ + "static/img/index-menu-2.ad0974f1.png";